import NavbarHeader from "./NavBar/NavbarHeader";
import Sidebar from "./NavBar/Sidebar";
import { useNavigation } from "../hooks/useNavigation";
import { useSidebar } from "../hooks/useSidebar";
import { NAVIGATION_ITEMS, BRAND_CONFIG } from "../constants/navigationConfig";

const MobileNav = ({
  navigationItems = NAVIGATION_ITEMS,
  brandConfig = BRAND_CONFIG,
  onItemClick,
  className = "",
}) => {
  const { isActiveRoute, navigateToRoute } = useNavigation();
  const { isOpen, toggleSidebar, closeSidebar } = useSidebar();

  const handleItemClick = (item) => {
    if (onItemClick) {
      onItemClick(item);
    } else {
      navigateToRoute(item.path, closeSidebar);
    }
  };

  return (
    <div className={className}>
      <NavbarHeader
        isOpen={isOpen}
        onToggle={toggleSidebar}
        brandConfig={brandConfig}
      />

      <Sidebar
        isOpen={isOpen}
        items={navigationItems}
        isActiveRoute={isActiveRoute}
        onItemClick={handleItemClick}
      />

      {/* Spacer for fixed navbar */}
      <div className="h-16" />
    </div>
  );
};

export default MobileNav;
